<template>
  <div
    v-if="!routing.isNationalPath()"
    class="text-xl font-bold mx-7 my-7"
  >
    ■{{ store }}
  </div>
  <div class="text-xl font-bold mx-7 my-7">
    ■{{ course }}
  </div>
  <div class="text-xl font-bold mx-7 my-7">
    ■{{ shipping }} 配送
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { useRouting } from '@/hooks/use_routing';
import { useState } from '@/hooks/use_state';

// import { Medium } from '@/models/medium';
// import ContentImage from './ContentImage.vue';
export default defineComponent({
  name: 'ContentCourseConfirm',
  components: {

    // ContentImage,
  },
  setup() {
    const state = useState();
    const routing = useRouting();
    const store = state.value.store;
    const course = state.value.course;
    const shipping = state.value.shipping;

    return {
      store,
      course,
      shipping,
      state,
      routing,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
